import App from '../../../../vendor_core/core/src/App';
import { IBetData } from '../../../../vendor_core/core/src/server/data/IBetData'
import Utils from '../../../../vendor_core/core/src/utils/Utils';
import BetDataParser from '../../../../vendor_core/src/server/parsers/BetDataParser'

export default class CCBetDataParser extends BetDataParser {
    parse(data): IBetData[] {
        const modifiedData = this.modifyDefaultBet(data);
        return super.parse(modifiedData)
    }

    modifyDefaultBet(data) {
        let creditsPerBet = Array.isArray(data.config.creditsPerBet)
                ? data.config.creditsPerBet[0]
                : data.config.creditsPerBet
        const legalBets = Utils.deepClone(data.limits.legalBets).map(bet => bet * creditsPerBet);
        const defaultBetIndex = legalBets.indexOf(data.limits.defaultBet);
        if (defaultBetIndex >= 0) {
            return data
        } else {
            const result = Utils.deepClone(data);
            result.limits.defaultBet = this.findClosestNumber(legalBets, data.limits.defaultBet);
            return result
        }
    }

    findClosestNumber(arr, target) {
        if (arr.length === 0) {
            return null;
        }

        let closest = arr[0];

        for (let i = 1; i < arr.length; i++) {
            if (Math.abs(arr[i] - target) < Math.abs(closest - target)) {
                closest = arr[i];
            }
        }
        // console.log("Closest number to", target, "is", closest);

        return closest;
    }
}
